import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import styled from "styled-components";
import {Header} from "@/components/Header";
import {NeoFrame} from "@/components/frames";
import {WidgetInfoContext} from "@/utils/widgetInfoProvider";
import { Rnd } from "react-rnd";

import "./OverlayWidget.css"

const Mobile = styled.div`
  
    display: flex;
    height: 100vh;
    flex-direction: column;
    position: relative;
    background: #000000;
    
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 100vh;
    flex-direction: column;
  }
`;

const Container = styled.div`
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Box = styled.div`
`;

export default function OverlayWidget() {
    const widgetContext = useContext(WidgetInfoContext);

    const onStart = (e, data) => {
        console.log(e, data)
    }

    const onStop = (e, data) => {
        console.log(e, data)
    }

    return (
        <Mobile>
            <Header title={"+ Add a widget"}/>

            <div style={{ display: 'flex', flex: 1}}>
                <Rnd style={{ color: 'green'}} bounds="parent" resizeHandleClasses={
                    {
                        bottom: 'edge edge-b',
                        bottomLeft: 'corner',
                        bottomRight: 'corner',
                        left: 'edge edge-l',
                        right: 'edge edge-r',
                        top: 'edge edge-t',
                        topLeft: 'corner',
                        topRight: 'corner',
                    }
                }>
                    <NeoFrame color={widgetContext?.widgetColor || 'green'} scale={1} content={widgetContext?.socialInfo}/>
                </Rnd>
            </div>
        </Mobile>
    );
}
